import { IComponentOptions } from 'angular';
import template from './buy-save-buttons.html';

export const BuySaveButtonComponent: IComponentOptions = {
    template,
    transclude: true,
};
